/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ResumeSubscriptionResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    resumeSubscription: build.mutation<ResumeSubscriptionResponse, void>({
      query: () => ({
        body: undefined,
        method: 'POST',
        url: `/v1/billing/subscription/resume`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as resumeSubscriptionApi };
export const { useResumeSubscriptionMutation } = injectedRtkApi;
